import { Box, Container, Input } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC, useState } from 'react';
import { useTypedSelector } from '../../../../store/store';
import { SignUpScreenStrings } from '../../../localization/en';
import { newFormatPhoneNumber } from '../../../../services/utilities';
import { useTrackEvent } from '../../../hooks/useTrackEvent';
import { EventNames } from '../../../constants/constants';

export const BottomPercent = '40%';

interface UserInfoBlockProps {
  onClick: (email?: string) => void;
}

const StyledContainer = styled(Container)({
  width: '100%',
  paddingLeft: 0,
  paddingRight: 0,
});

const Wrapper = styled(Box)({
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  border: '1px solid #2D11AD',
});

// const FormLabel = styled('p')({
//   color: '#475467',
//   fontSize: '18px',
//   fontWeight: 400,
//   margin: '16px 8px',
// });

const AuthSubmitBtn = styled('button')({
  marginTop: '12px',
  backgroundColor: '#2D11AD',
  color: '#fff',
  width: '100%',
  height: '12.2vw',
  maxHeight: '52px',
  fontSize: 'clamp(16px, 4.4vw, 24px)',
  fontWeight: 400,
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  
  '&:hover': {
    backgroundColor: '#2D11AD',
    boxShadow: 'unset',
  },
  
  '&:disabled': {
    backgroundColor: '#ccc',
    color: '#666',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
});

const StyledInput = styled(Input)({
  width: '100%',
  height: '12.2vw',
  maxHeight: '52px',
  border: '1px solid',
  borderRadius: '8px',
  borderColor: '#D0D5DD',
  marginBottom: '10px',
  background: 'white',
  paddingLeft: '12px',
  color: '#2D11AD',
  
  '& input': {
    color: '#2D11AD !important',
    fontSize: 'clamp(16px, 4.4vw, 24px)',
    '&::placeholder': {
      color: '#A9B3C8',
    },
  },
  
  '&.Mui-error': {
    borderColor: '#ED2E38',
  },
});

const Title = styled('p')({
  fontWeight: 600,
  color: '#2D11AD',
  fontSize: 'clamp(13px,4.2vw,18px)',
  whiteSpace: 'nowrap',
  margin: '0px 10px 10px 5px',
  lineHeight: '24px',
});

export const UserInfoBlock: FC<UserInfoBlockProps> = ({ onClick }) => {
  const { firstName, lastName, phoneNumber } = useTypedSelector((state) => state.me);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const { trackEvent } = useTrackEvent();

  const formatterNumber =
    phoneNumber.substring(0, 2) === '+1' ? newFormatPhoneNumber(phoneNumber, { showPlusOne: false }) : phoneNumber;

  const emailRequired = false;
  
  const handleEmailChange = (e: { target: { value: string } }) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (!validateEmail(newEmail)) {
      setEmailError('Invalid email address');
    } else {
      setEmailError('');
    }
  };
  
  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
  const handleEmailBlur = async () => {
    validateEmail(email);
    handleBlur({ target: { value: email, name: 'email' } });
  };

  const handleBlur = (e: { target: { value: string; name: string } }) => {
    trackEvent({ action: EventNames.input_field_focus, name: e.target.name, value: e.target.value });
  };

  return (
    <StyledContainer>
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'flex-start'}
        flexDirection={'column'}
        padding="30px 30px"
        component={Wrapper}
        style={{ padding: '16px', borderRadius: '8px' }}
      >
        <Title>{SignUpScreenStrings.GetCredit}</Title>

        <Box display={'flex'} gap="10px">
          <StyledInput
            value={firstName}
            disableUnderline={true}
            name="firstName"
            placeholder={SignUpScreenStrings.First}
            onBlur={handleBlur}
            disabled
          />

          <StyledInput
            value={lastName}
            disableUnderline={true}
            name="lastName"
            placeholder={SignUpScreenStrings.Last}
            onBlur={handleBlur}
            disabled
          />
        </Box>
        
        <StyledInput
          value={formatterNumber}
          disableUnderline={true}
          name="phoneNumber"
          placeholder={SignUpScreenStrings.Last}
          style={{ width: '100%', marginBottom: emailRequired ? '10px' : 'unset' }}
          onBlur={handleBlur}
          disabled
        />
        
        {emailRequired && (
          <StyledInput
            value={email}
            onChange={handleEmailChange}
            disableUnderline={true}
            error={!!emailError}
            name="email"
            placeholder={'Enter an email'}
            onBlur={handleEmailBlur}
            style={{ width: '100%', marginBottom: 'unset' }}
          />
        )}
        
        <AuthSubmitBtn
          style={{
            height: '52px',
            borderRadius: '12px',
            width: '100%',
          }}
          disabled={emailRequired ? (email.length && !emailError.length ? false : true) : false}
          onClick={() => {
            onClick(email);
          }}
        >
          Next
        </AuthSubmitBtn>
      </Box>
    </StyledContainer>
  );
};
